import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Hizmetler from "../pages/hizmetler/page";
import Tamir from "../pages/hizmetler/tamir/page";
import Bakim from "../pages/hizmetler/bakim/page";
import Kurulum from "../pages/hizmetler/kurulum/page";
import Hakkimizda from "../pages/hakkimizda/page";
import Iletisim from "../pages/iletisim/page";
import Markalar from "../pages/markalar/page";
import MarkaAnycubic from "../pages/markalar/anycubic/page";
import MarkaCreality from "../pages/markalar/creality/page";
import MarkaElegoo from "../pages/markalar/elegoo/page";
import MarkaBambuLab from "../pages/markalar/bambu-lab/page";
import MarkaFlashforge from "../pages/markalar/flashforge/page";
import MarkaSnapmaker from "../pages/markalar/snapmaker/page";
import MarkaFlsun from "../pages/markalar/flsun/page";
import AdminLoginPage from "../pages/admin/login/page";
import AdminPage from "../pages/admin/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hizmetler",
    element: <Hizmetler />,
  },
  {
    path: "/hizmetler/tamir",
    element: <Tamir />,
  },
  {
    path: "/hizmetler/bakim",
    element: <Bakim />,
  },
  {
    path: "/hizmetler/kurulum",
    element: <Kurulum />,
  },
  {
    path: "/hakkimizda",
    element: <Hakkimizda />,
  },
  {
    path: "/iletisim",
    element: <Iletisim />,
  },
  {
    path: "/markalar",
    element: <Markalar />,
  },
  {
    path: "/markalar/anycubic",
    element: <MarkaAnycubic />,
  },
  {
    path: "/markalar/creality",
    element: <MarkaCreality />,
  },
  {
    path: "/markalar/elegoo",
    element: <MarkaElegoo />,
  },
  {
    path: "/markalar/bambu-lab",
    element: <MarkaBambuLab />,
  },
  {
    path: "/markalar/flashforge",
    element: <MarkaFlashforge />,
  },
  {
    path: "/markalar/snapmaker",
    element: <MarkaSnapmaker />,
  },
  {
    path: "/markalar/flsun",
    element: <MarkaFlsun />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin/*',
    element: <AdminPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
